import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase/client';

interface Campaign {
  id: string;
  name: string;
  user_id: string;
  created_at: string;
  status: string;
}

const CampaignDebugger: React.FC = () => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const testCampaignQuery = async () => {
      try {
        console.log('Testing basic campaign query...');
        
        const { data, error } = await supabase
          .from('campaigns')
          .select('*')
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Campaign query error:', error);
          setError(error.message);
        } else {
          console.log('Campaign query success:', data);
          setCampaigns(data || []);
        }
      } catch (err) {
        console.error('Campaign query exception:', err);
        setError('Query failed with exception');
      } finally {
        setLoading(false);
      }
    };

    testCampaignQuery();
  }, []);

  if (loading) {
    return <div>Testing campaign query...</div>;
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Campaign Debugger</h2>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          Error: {error}
        </div>
      )}
      
      <div className="bg-gray-100 p-4 rounded mb-4">
        <h3 className="font-semibold">Query Results:</h3>
        <p>Found {campaigns.length} campaigns</p>
      </div>
      
      {campaigns.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 text-left">ID</th>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">User ID</th>
                <th className="px-4 py-2 text-left">Created</th>
                <th className="px-4 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((campaign, index) => (
                <tr key={campaign.id || index} className="border-t">
                  <td className="px-4 py-2">{campaign.id}</td>
                  <td className="px-4 py-2">{campaign.name}</td>
                  <td className="px-4 py-2">{campaign.user_id}</td>
                  <td className="px-4 py-2">{new Date(campaign.created_at).toLocaleString()}</td>
                  <td className="px-4 py-2">{campaign.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CampaignDebugger;
